import React from 'react';
import styled, { css } from 'styled-components';
import breakpoints from 'src/integration/styles/breakpoints';
import Dropdown from 'src/presentation/components/ui/DropdownButton';
import StyledDatePicker from 'src/presentation/components/ui/StyledDatePicker';
import { Option } from 'src/integration/types/Option';
import { useStore } from 'src/integration/store/store';
import dayjs from 'dayjs';
import Skeleton from 'src/presentation/components/ui/Skeleton';

interface ComponentProps {
  fleetOptions: Option[];
  currentFleetId: Nullable<number>;
  date: string;
  isLoading: boolean;
}

const Root = styled.div`
  ${() => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 48px 0 56px;
  `}
`;

const NavWrapper = styled.div`
  ${() => css`
      display: flex;
      align-items: center;
      gap: 24px;
  `}
`;

const FleetNavigation = ({fleetOptions, currentFleetId, date, isLoading}: ComponentProps) => {
  const { settingsStore} = useStore();

  if (isLoading) {
    return (
      <Root>
        <NavWrapper>
          <Skeleton width={180} height={50} borderRadius={50}/>
          <Skeleton width={300} height={50} borderRadius={50}/>
        </NavWrapper>
      </Root>

    )
  }

  return (
    <Root>
      <NavWrapper>
          <Dropdown
            options={fleetOptions}
            selectedId={currentFleetId}
            onChange={(id: Nullable<number>) => settingsStore.setSiteId(id)} />
          <StyledDatePicker
            selectedDate={dayjs(date).toDate()}
            onChange={(date: Date | null) => settingsStore.setSelectedDate(dayjs(date).format('YYYY-MM-DD'))}
          />
      </NavWrapper>
    </Root>
  );
};

export default FleetNavigation;
